<template>
  <label :for="name" class="block text-sm font-medium text-gray-700 mb-1">
    <span class="inline-flex items-center gap-1">
      <slot></slot>
      <slot name="tooltip"></slot>
    </span>
  </label>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    name: {
      type: String,
    },
  },
  setup() {
    return {};
  },
});
</script>

<style scoped></style>
